import {
  AppDispatch,
  deleteOrganization,
  deleteOrganizationClear,
  deleteOrganizationRequest,
  getChildOrganizationListRequest,
  getOrganizationListRequest,
} from "@src/redux";
import { Button } from "antd";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

interface WorkersDeleteModalProps {
  onCancel: () => void;

  worker: {
    name: string;
    id: string;
  };
}

const WorkersDeleteModal: React.FC<WorkersDeleteModalProps> = ({
  worker,
  onCancel,
}) => {
  const {
    result: deleteOrganizationResult,
    loading: deleteOrganizationLoading,
  } = useSelector(deleteOrganization);
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { id: organizationId } = useParams();

  useEffect(() => {
    if (deleteOrganizationResult?.status === "success") {
      toast.success(t("delete_organization_success"));

      dispatch(deleteOrganizationClear());
      onCancel();
      dispatch(getOrganizationListRequest({}));
      dispatch(
        getChildOrganizationListRequest({
          filter: {
            parentOrganizationId: organizationId || "",
          },
          pagination: {
            pageLimit: 10,
            pageNumber: 1,
          },
        })
      );
    }
  }, [deleteOrganizationResult?.status]);

  const handleDelete = () => {
    dispatch(
      deleteOrganizationRequest({
        id: worker?.id || "",
      })
    );
  };

  return (
    <div>
      <span>{`Are you sure you want to delete the "${worker?.name}" ?`}</span>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button style={{ marginRight: "10px" }} onClick={onCancel} danger>
          {t("close")}
        </Button>
        <Button
          className="delete-role-button"
          type="primary"
          danger
          onClick={handleDelete}
          loading={deleteOrganizationLoading}
        >
          {t("delete")}
        </Button>
      </div>
    </div>
  );
};

export default WorkersDeleteModal;
